import type { DateTextInputProps, DatePart } from '../../DateTextInput.types'

export default function goToInputOfType(id: DateTextInputProps['id'], type: DatePart): void {
  const input = document.getElementById(`${id}-${type}`) as HTMLInputElement
  if (input) {
    input.select()
  }
}
